import { useMutation } from "react-query";

import api from "../../../api";

const toggleEditPermissionService = async ({ handle, editPermission }) => {
  const { data } = await api.put(`/p/${handle}/access`, {
    is_user_editable: editPermission,
  });
  return data;
};

export const useToggleEditPermissionMutation = () => {
  const [mutate, { ...mutationProps }] = useMutation(
    toggleEditPermissionService,
  );

  return {
    mutate,
    ...mutationProps,
  };
};
